import angular from 'angular';
import {
  loaderService,
  pmDataService,
  pmSharedModelService,
  ssDialogService,
} from 'app/services';
import {
  alerts,
  actionIcon,
} from 'app/components/global';

import settingsDialog from '../../../../dialog.settingsDialog';
import directive from './tokens-tab-panel.directive';
import controller from './tokens-tab-panel.controller';


export default angular.module('app.components.advisory.pm.tokensTabPanel', [
  actionIcon,
  alerts,
  loaderService,
  pmDataService,
  pmSharedModelService,
  settingsDialog,
  ssDialogService,
])
  .directive('pmTokensTabPanel', directive)
  .controller('TokensTabPanelController', controller)
  .name;

console.log('app.components.advisory.pm.tokensTabPanel created');
